import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { COMPANY_OPTIONS_SETTLEMENT_MONTHS } from "@/libs/constants";
import { FormErrorMessage, FormSelectBox } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

export const SettlementMonthFormField = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          決算月 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={fieldWrapper}>
          <FormSelectBox
            name={props.name}
            placeholder={"未選択"}
            options={COMPANY_OPTIONS_SETTLEMENT_MONTHS}
            registerOptions={{
              required: "選択してください",
            }}
          />
          <FormErrorMessage name={props.name} />
        </div>
        <div css={unitWrapper}>
          <Font variant="m">月</Font>
        </div>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const fieldWrapper = css({
  maxWidth: "120px",
});

const unitWrapper = css({
  marginLeft: "16px",
});
